module.exports = Compressor;